// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

// Import Services
import NotificationService from '../../../../../services/NotificationService/NotificationService';

// Import Icons
import DeleteIcon from '../../../../../../src/assets/icons/dasboardIcons/notification-delete-icon.svg';
import ReadIcon from '../../../../../../src/assets/icons/dasboardIcons/notification-read-icon.svg';
import UnreadIcon from '../../../../../../src/assets/icons/dasboardIcons/unread-icon.svg';

// Import Material UI
import { Checkbox, Dialog, DialogContent, DialogTitle, Tooltip } from '@material-ui/core'
import { Close } from '@material-ui/icons'

// Import Pages
import { CustomNotificationCheckbox } from '../../../../../components/FlowConfigurationInputs';

// Import Recoil
import { personalizationState } from '../../../../../recoil-store/recoil-state';
import { useRecoilValue } from 'recoil';

// Import Helper
import { convertToDateFormat } from '../../../../../helpers/helper';


const FullScreenNotifications = ({ handleClose, label, item, handleShowTitle, handleOpenNotificationDetail, handleCheckBox, handleRead,
    selectedNotifications, handleCheckedFound, setRefresh, handleReadNotifications, handleDelete, detectSelectedNotifications, handleSelectAll, clearAll }) => {
    const [allNotifications, setAllNotifications] = useState([])
    const personalization = useRecoilValue(personalizationState);
    const { t } = useTranslation();

    useEffect(() => {
        const fetchNotificationData = async () => {
            const response = await NotificationService.getNotifications(null)
            if (response.status) {
                setAllNotifications(response.data)
            }
        }
        fetchNotificationData();
    }, []);

    return (
        <Dialog
            id="full-notifications-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: "95%",
                    maxWidth: "95%",
                    width: "100%",
                    height: "100%",
                    borderRadius: " 4px",
                    padding: "4px 22px 40px 22px"
                },
            }}
        >
            <DialogTitle id="notification-dialog-title">
                <div id="about-title" className="add-group-header all-logs-header">
                    <div>
                        <h4 className="notifications-name-title">{t(label + "ALL-NOTIFICAITONS")}</h4>
                        <small
                            className="conf-field-desc"><em>{t(label + "ALL-NOTIFICAITONS-DESCRIPTION")}</em></small>
                    </div>
                    <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                </div>
                <div className='db-notification-header-actions-container'>
                    {
                        selectedNotifications?.length ?
                            <span className='db-notification-select-all' onClick={clearAll}>{t(label + 'CLEAR-ALL')}</span>
                            :
                            <span className='db-notification-select-all' onClick={() => handleSelectAll(allNotifications)}>{t(label + 'SELECT-ALL')}</span>
                    }
                    {
                        selectedNotifications.length ?
                            <div className={`db-notification-header-actions ${selectedNotifications.length ? "" : "o-0-5"}`}>
                                {
                                    detectSelectedNotifications(setAllNotifications)
                                }
                                {/* <div className='db-notification-header-read-container' onClick={() => handleReadNotifications(selectedNotifications, setAllNotifications)}>
                                    <img className='db-notification-single-read-icon' src={ReadIcon} />
                                    <span>{t(label + 'MARK-AS-READ')}</span>
                                </div> */}
                                <div className='db-notification-header-delete-container' onClick={() => handleDelete(selectedNotifications, setAllNotifications)}>
                                    <img className='db-notification-single-delete-icon' src={DeleteIcon} />
                                    <span>{t(label + 'DELETE')}</span>
                                </div>
                            </div> : undefined
                    }
                </div>
            </DialogTitle>
            <DialogContent className='db-all-notifications-container'>
                {allNotifications.map((item, itemI) => {
                    const isChecked = handleCheckedFound(item)
                    return (
                        <div className={`db-notification-item ${item.read_status ? "db-readed-notification-item" : ""}`} key={itemI}>
                            <div className='db-notification-title-container'>
                                <div className='db-notification-title-and-checkbox'>
                                    <CustomNotificationCheckbox checked={isChecked} onChange={(e) => {
                                        handleCheckBox(e, item)
                                        setRefresh((pre) => !pre)
                                    }} />
                                    <div className='db-notification-title-desc-container' onClick={() => handleOpenNotificationDetail(item, setAllNotifications)}>
                                        {/* {handleShowTitle(item.title, false)} {item.description !== "-" ? `- ${handleShowTitle(item.description, true)}` : ""} */}
                                        <span className={`notification-title ${item.read_status ? 'unread-notification-color' : ''}`}>{handleShowTitle(item.title, false)}</span>
                                        {item.description !== "-" ? (
                                            <>
                                                <span className={`notification-desc ${item.read_status ? 'unread-notification-color' : ''}`}>{" - "}{handleShowTitle(item.description, true)}</span>
                                            </>
                                        ) : ""}
                                    </div>
                                </div>
                                <div className={`db-seclabel db-notification-date ${item.read_status ? 'unread-notification-color' : ''}`}>{convertToDateFormat(item.created_at, personalization.date_format)}</div>
                            </div>
                            <div className='db-notification-actions-container'>
                                <Tooltip title={t(label + (item.read_status ? 'MARK-AS-UNREAD' : 'MARK-AS-READ'))} placement='top'>
                                    <img className={`db-notification-single-read-icon ${item.read_status ? "o-0-5" : ""}`} src={item.read_status ? UnreadIcon : ReadIcon} onClick={() => handleReadNotifications(item, setAllNotifications, item.read_status ? 0 : 1)} />
                                </Tooltip>
                                <Tooltip title={t(label + 'DELETE')} placement='top'>
                                    <img className='db-notification-single-delete-icon' src={DeleteIcon} onClick={() => handleDelete(item, setAllNotifications)} />
                                </Tooltip>
                            </div>
                        </div>
                    );
                })}
            </DialogContent>

        </Dialog>
    )
}

export default FullScreenNotifications